const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:3001";

interface WebChatMessage {
    id: number;
    conversationId: number;
    direction: "inbound" | "outbound";
    body: string;
    isActivio: boolean;
    sentAt: string;
}

interface InitSessionResponse {
    sessionId: string;
}

interface SendMessageResponse {
    messageId: number;
    aiResponse?: {
        body: string;
        messageId: number;
        analysis?: any;
    };
}

interface GetMessagesResponse {
    messages: WebChatMessage[];
}

async function fetchAPI<T>(
    endpoint: string,
    options?: RequestInit,
): Promise<T> {
    const url = `${API_BASE_URL}/api${endpoint}`;

    const response = await fetch(url, {
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });

    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.json();
}

export const webChatService = {
    /**
     * Initialize a new web chat session
     */
    initSession: (type?: string): Promise<InitSessionResponse> => {
        return fetchAPI<InitSessionResponse>("/v1/web-chat/init", {
            method: "POST",
            body: JSON.stringify(type ? { type } : {}),
        });
    },

    /**
     * Send a message from a visitor
     */
    sendMessage: (
        sessionId: string,
        message: string,
    ): Promise<SendMessageResponse> => {
        return fetchAPI<SendMessageResponse>("/v1/web-chat/messages", {
            method: "POST",
            body: JSON.stringify({ sessionId, message }),
        });
    },

    /**
     * Get all messages for a session
     */
    getMessages: (sessionId: string): Promise<GetMessagesResponse> => {
        return fetchAPI<GetMessagesResponse>(
            `/v1/web-chat/messages/${sessionId}`,
        );
    },

    /**
     * Update visitor information
     */
    updateVisitorInfo: (
        sessionId: string,
        data: { name?: string; email?: string; phone?: string },
    ): Promise<{ success: boolean }> => {
        return fetchAPI<{ success: boolean }>("/v1/web-chat/visitor-info", {
            method: "PATCH",
            body: JSON.stringify({ sessionId, ...data }),
        });
    },
};
